import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DepartmentSchema, type Department, type PatchDepartmentInput } from '@magimp/shared';
import { useApiClient } from '../api/context.js';

export function usePatchDepartment(id: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<Department, unknown, PatchDepartmentInput>({
    mutationFn: (input) =>
      client.patch<Department>(`/departments/${id}`, input, {}, DepartmentSchema),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['departments', 'list'] });
      qc.invalidateQueries({ queryKey: ['department', id] });
    },
  });
}
